import { Link } from "react-router-dom";
import Logo from "./Logo";
import { BRAND, NAV_LINKS, LEGAL } from "@/data/site";

const COLS = [
  {
    head: "Treatment",
    links: [
      { label: "What is TRT?", to: "/testosterone-treatment" },
      { label: "Am I eligible?", to: "/trt-eligibility" },
      { label: "Treatment options", to: "/trt-treatment-options" },
      { label: "Ongoing monitoring", to: "/trt-monitoring" },
    ],
  },
  {
    head: "Service",
    links: [
      { label: "Blood testing", to: "/testosterone-testing" },
      { label: "Fees & plans", to: "/trt-cost" },
      { label: "Switch to us", to: "/switch-trt-clinic" },
      { label: "Knowledge centre", to: "/learn" },
    ],
  },
  {
    head: "Trust",
    links: [
      { label: "Clinical safety", to: "/safety" },
      { label: "Clinical team", to: "/clinical-team" },
      { label: "Why Androgen Health", to: "/why-androgen-health" },
      { label: "Contact & complaints", to: "/contact" },
    ],
  },
  {
    head: "Legal",
    links: [
      { label: "Privacy notice", to: "/privacy" },
      { label: "Patient portal", to: "/portal" },
      { label: "Terms of service", to: "/terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-line bg-surface/40" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <Logo />
            <p className="serif-it text-lg text-mute mt-5 max-w-xs">{BRAND.strapline}</p>
            <p className="mono-label text-dusk mt-6">{BRAND.positioning}</p>
          </div>
          {COLS.map((col) => (
            <nav key={col.head} aria-label={col.head}>
              <p className="mono-label text-teal mb-4">{col.head}</p>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link to={l.to} className="text-sm text-mute hover:text-bone transition-colors link-underline">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-line space-y-3">
          <p className="text-xs text-dusk leading-relaxed">{BRAND.pomNote}</p>
          <p className="text-xs text-dusk leading-relaxed">
            {BRAND.safety} Androgen Health is a trading name; regulatory registration details will
            be published here prior to launch. Content on this site is for information only and is
            not a substitute for medical advice. Proposed launch pricing shown; final fees confirmed
            before going live.
          </p>
          <p className="text-xs text-dusk pt-2 leading-relaxed max-w-3xl" data-testid="footer-legal">© {new Date().getFullYear()} Androgen Health. {LEGAL.line}</p>
        </div>
      </div>
    </footer>
  );
}
